import React from 'react';
import { cn } from './utils';

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}

const sizeClass: Record<SpinnerSize, string> = {
  sm: 'bh-spinner--sm',
  md: 'bh-spinner--md',
  lg: 'bh-spinner--lg',
};

export function Spinner({ size = 'md', className, label = 'Loading' }: SpinnerProps) {
  return (
    <span
      className={cn('bh-spinner', sizeClass[size], className)}
      role="status"
      aria-label={label}
    />
  );
}
